(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    "use strict";
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.state = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.score = 0;
        this.status = "idle";
        this.messages = (0, $227c6742e0ff6f82$export$71511d61b312f219)(document.querySelectorAll(".message"));
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing") return;
                this.moved = false;
                for(var i = 0; i < this.state.length; i++){
                    var merged = this.mergeLine((0, $227c6742e0ff6f82$export$71511d61b312f219)(this.state[i]));
                    if (merged.toString() !== this.state[i].toString()) this.moved = true;
                    this.state[i] = merged;
                }
                this.afterMove();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "playing") return;
                this.moved = false;
                for(var i = 0; i < this.state.length; i++){
                    var merged = this.mergeLine((0, $227c6742e0ff6f82$export$71511d61b312f219)(this.state[i]).reverse()).reverse();
                    if (merged.toString() !== this.state[i].toString()) this.moved = true;
                    this.state[i] = merged;
                }
                this.afterMove();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var column = _this.state.map(function(row) {
                        return row[col];
                    });
                    var merged = _this.mergeLine(column);
                    for(var row = 0; row < 4; row++)if (_this.state[row][col] !== merged[row]) {
                        _this.state[row][col] = merged[row];
                        _this.moved = true;
                    }
                };
                if (this.status !== "playing") return;
                this.moved = false;
                for(var col = 0; col < 4; col++)_loop(col);
                this.afterMove();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var column = _this.state.map(function(row) {
                        return row[col];
                    });
                    var merged = _this.mergeLine((0, $227c6742e0ff6f82$export$71511d61b312f219)(column).reverse()).reverse();
                    for(var row = 0; row < 4; row++)if (_this.state[row][col] !== merged[row]) {
                        _this.state[row][col] = merged[row];
                        _this.moved = true;
                    }
                };
                if (this.status !== "playing") return;
                this.moved = false;
                for(var col = 0; col < 4; col++)_loop(col);
                this.afterMove();
            }
        },
        {
            key: "mergeLine",
            value: function mergeLine(line) {
                var result = line.filter(function(val) {
                    return val !== 0;
                });
                for(var i = 0; i < result.length - 1; i++)if (result[i] === result[i + 1]) {
                    result[i] *= 2;
                    this.score += result[i];
                    result[i + 1] = 0;
                    this.moved = true;
                }
                result = result.filter(function(val) {
                    return val !== 0;
                });
                while(result.length < 4)result.push(0);
                return result;
            }
        },
        {
            key: "afterMove",
            value: function afterMove() {
                if (this.moved) {
                    this.addRandomTile();
                    this.getScore();
                    this.updateDOM();
                }
                this.getStatus();
                this.updateButton();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                this.gameScore = document.querySelector(".game-score");
                if (this.gameScore) this.gameScore.innerHTML = this.score;
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                if (this.status === "idle") return "idle";
                for(var i = 0; i < this.state.length; i++){
                    for(var j = 0; j < this.state[i].length; j++)if (this.state[i][j] === 2048) {
                        this.status = "win";
                        for(var k = 0; k < this.messages.length; k++)if (this.messages[k].classList.contains("message-win")) this.messages[k].classList.remove("hidden");
                        return "win";
                    }
                }
                if (!this.canMove()) {
                    this.status = "lose";
                    for(var k1 = 0; k1 < this.messages.length; k1++)if (this.messages[k1].classList.contains("message-lose")) this.messages[k1].classList.remove("hidden");
                    return "lose";
                }
                this.status = "playing";
                return "playing";
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "idle") {
                    for(var i = 0; i < this.messages.length; i++)if (this.messages[i].classList.contains("message-start")) this.messages[i].classList.add("hidden");
                    this.status = "playing";
                    this.addRandomTile();
                    this.addRandomTile();
                    this.updateDOM();
                    this.updateButton();
                } else this.restart();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = "idle";
                for(var i = 0; i < this.messages.length; i++)if (this.messages[i].classList.contains("message-start")) this.messages[i].classList.remove("hidden");
                else this.messages[i].classList.add("hidden");
                this.getScore();
                this.updateDOM();
                this.updateButton();
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyTiles = [];
                for(var i = 0; i < this.state.length; i++){
                    for(var j = 0; j < this.state[i].length; j++)if (this.state[i][j] === 0) emptyTiles.push([
                        i,
                        j
                    ]);
                }
                if (emptyTiles.length > 0) {
                    var _emptyTiles_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyTiles[Math.floor(Math.random() * emptyTiles.length)], 2), row = _emptyTiles_Math_floor[0], col = _emptyTiles_Math_floor[1];
                    this.state[row][col] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "updateDOM",
            value: function updateDOM() {
                this.squares = (0, $227c6742e0ff6f82$export$71511d61b312f219)(document.querySelectorAll(".field-cell"));
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    var index = i * 4 + j;
                    if (this.squares[index]) {
                        this.squares[index].textContent = this.state[i][j] === 0 ? "" : this.state[i][j];
                        this.addColors();
                    }
                }
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    if (this.state[i][j] === 0) return true;
                    if (j < 3 && this.state[i][j] === this.state[i][j + 1]) return true;
                    if (i < 3 && this.state[i][j] === this.state[i + 1][j]) return true;
                }
                return false;
            }
        },
        {
            key: "addColors",
            value: function addColors() {
                for(var i = 0; i < this.squares.length; i++){
                    var value = parseInt(this.squares[i].textContent);
                    this.squares[i].className = "field-cell";
                    if (value) this.squares[i].classList.add("field-cell--".concat(value));
                }
            }
        },
        {
            key: "updateButton",
            value: function updateButton() {
                var mainButton = document.querySelector("button");
                if (mainButton) {
                    if (this.status === "idle") {
                        mainButton.classList.remove("restart");
                        mainButton.classList.add("start");
                        mainButton.textContent = "Start";
                    } else if (this.status === "playing" || this.status === "win" || this.status === "lose") {
                        mainButton.classList.remove("start");
                        mainButton.classList.add("restart");
                        mainButton.textContent = "Restart";
                    }
                }
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


document.addEventListener("DOMContentLoaded", function() {
    var control = function control(e) {
        switch(e.key){
            case "ArrowLeft":
                keyLeft();
                break;
            case "ArrowRight":
                keyRight();
                break;
            case "ArrowUp":
                keyUp();
                break;
            case "ArrowDown":
                keyDown();
                break;
        }
    };
    var keyLeft = function keyLeft() {
        game.moveLeft();
    };
    var keyRight = function keyRight() {
        game.moveRight();
    };
    var keyUp = function keyUp() {
        game.moveUp();
    };
    var keyDown = function keyDown() {
        game.moveDown();
    };
    var btn = document.querySelector("button");
    var game = new $3d28d7f1aac198f5$exports();
    btn.addEventListener("click", function() {
        game.start();
    });
    document.addEventListener("keydown", control);
});

})();
//# sourceMappingURL=index.63b51cf8.js.map
